import { Observable } from 'rxjs';
import { fetchProjectListAPI } from '../../api/fetch-functions/project';
import { IProjectType } from '../../types/record/project';
import { ListWithPromiseState } from './common/list-with-status';
import {
  fetchIdStreamGenerator,
  fetchListFnGenerator,
  listOfIdFnGenerator,
  oneIdListSetReducerGenerator,
  oneIdListSetStreamGenerator,
  updateStreamGenerator
} from './common/one-id-list';

const fetchSignal$ = fetchIdStreamGenerator();

// 仮引数のリネームのためいったん変数`f`に格納
const f = fetchListFnGenerator(fetchSignal$);
export const fetchProjectListOf = (companyId: number) => f(companyId);

/**
 * @description
 * `fetchProjectListOf(companyId)` を実行すると
 * `projectListSet$` の該当idの要素を re-fetch する．
 */
const updateProjectList$ = updateStreamGenerator(
  fetchSignal$,
  fetchProjectListAPI
);

const projectListSetReducer = oneIdListSetReducerGenerator<IProjectType>();

/**
 * @description
 * すべての projectList の集合．必要になったものからfetchして蓄える．
 * 複数のcomponentで共有するため．
 */
const projectListSet$ = oneIdListSetStreamGenerator(
  updateProjectList$,
  projectListSetReducer
);

const g = listOfIdFnGenerator(projectListSet$);
export const projectListOf = (
  companyId: number
): Observable<ListWithPromiseState<IProjectType>> => {
  fetchProjectListOf(companyId);
  return g(companyId);
};
